/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionBrowseHost
 */
export interface CompetitionBrowseHost {
    /**
     * Display name of the Drop hosting this competition, or the sponsoring Brand.
     * @type {string}
     * @memberof CompetitionBrowseHost
     */
    name: string;
    /**
     * Hex colour for the host lockup. Only a Brand carries one.
     * @type {string}
     * @memberof CompetitionBrowseHost
     */
    brandColor?: string | null;
    /**
     * The ACCESS POINT — where the player goes to play. A verified custom domain, else the platform route. Absent for a Brand sponsor, whose competition lives on our own page.
     * @type {string}
     * @memberof CompetitionBrowseHost
     */
    url?: string | null;
    /**
     * True when url is a partner hostname. The desktop shell must open it via openExternal rather than navigating the main window.
     * @type {boolean}
     * @memberof CompetitionBrowseHost
     */
    external: boolean;
}

/**
 * Check if a given object implements the CompetitionBrowseHost interface.
 */
export function instanceOfCompetitionBrowseHost(value: object): value is CompetitionBrowseHost {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('external' in value) || value['external'] === undefined) return false;
    return true;
}

export function CompetitionBrowseHostFromJSON(json: any): CompetitionBrowseHost {
    return CompetitionBrowseHostFromJSONTyped(json, false);
}

export function CompetitionBrowseHostFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionBrowseHost {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'url': json['url'] == null ? undefined : json['url'],
        'external': json['external'],
    };
}

export function CompetitionBrowseHostToJSON(json: any): CompetitionBrowseHost {
    return CompetitionBrowseHostToJSONTyped(json, false);
}

export function CompetitionBrowseHostToJSONTyped(value?: CompetitionBrowseHost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'brandColor': value['brandColor'],
        'url': value['url'],
        'external': value['external'],
    };
}

